import { useContext } from "react";
import { Modal } from "react-overlays";
import UserContext from "../context/user";
import Icon from "./icon";

const renderBackdrop = (props) => <div className="backdrop" {...props} />;

const LogoutModal = ({ show, closeModal, labels }) => {
  const { logout } = useContext(UserContext);

  const handleLogout = () => {
    logout();
    closeModal();
  };

  return (
    <Modal
      show={show}
      onHide={closeModal}
      aria-labelledby="modal-label"
      className="modal modal--borse dark-mode"
      renderBackdrop={renderBackdrop}
      onBackdropClick={closeModal}
      aria-hidden="false"
      aria-modal="true"
    >
      <>
        <button
          type="button"
          onClick={closeModal}
          className="close-button"
          aria-label={labels?.CLOSE}
        >
          <Icon name="cross" />
        </button>
        <div className="modal__body wrapper">
          <h1 className="modal__title">
            {labels?.WELFARE_LOGOUT_MODAL_TITLE || "Do you really want to quit the page?"}
          </h1>
          <p className="modal__description">{labels?.WELFARE_LOGOUT_MODAL_TEXT}</p>
          <div className="modal__buttons">
            <button className="button secondary" onClick={closeModal}>
              {labels?.WELFARE_LOGOUT_MODAL_CTA_SEC || "No, stay on the page"}
            </button>
            <button className="button primary" onClick={handleLogout}>
              {labels?.WELFARE_LOGOUT_MODAL_CTA_PRI || "Quit"}
              <Icon name="share" />
            </button>
          </div>
        </div>
      </>
    </Modal>
  );
};

export default LogoutModal;
